import React from "react";
import { aiLoader } from "../../assets";

const AiLoader = ({ message = "" }) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[50vh] tw-overflow-hidden tw-relative">
      <div className="tw-relative tw-flex tw-items-center tw-justify-center">
        <video
          src={aiLoader}
          width="200"
          height="200"
          autoPlay
          loop
          muted
          playsInline
          className="tw-object-contain"
        />
      </div>
      {message && <p>{message}</p>}
    </div>
  );
};

export default AiLoader;
